import { IUserAuthInfo } from 'shared/models/user-auth-info';
import { IUserUnavailableDetail } from 'shared/models';
import { UserJsonLDUtil } from 'shared/models/user/json-ld-util';

export interface IUserDetail {
  userId: string;
  avatar: string;
  authInfo: IUserAuthInfo;
  nickName: string;
  linkName: string;

  gender: EUserGender;
  ageGroup?: number;
  location?: string;

  description: string;

  postCount: number;
  diggCount: number;
  dugCount: number;
  favoriteCount: number;
  favoredCount: number;
  followingCount: number;
  followerCount: number;

  thirdLinks: {
    platform: string;
    name: string;
    url: string;
  }[];

  privacyStatus: EPrivacyStatus;

  // banned account
  isBannedAccount: boolean;
}

export enum EUserGender {
  Unknown = 0,
  MALE = 1,
  FEMALE = 2,
}

export enum EPrivacyStatus {
  Normal = -1,
  UserPageNoPermission = 0,
  UserPageHasPermission = 1,
  PrivateUser = 2,
  UnderAge = 3,
}

export const UserDetailUtil = {
  isUserAvailable: (user: IUserDetail | IUserUnavailableDetail): user is IUserDetail => {
    return !('unavailableReason' in user);
  },
  JsonLD: UserJsonLDUtil,
};
